import gql from "graphql-tag";

export const GET_FUNDS = gql`
    query getFoNavFunds {
        funds: parties(filter: { typeIn: [Fund] }) {
            _id
            name
            accountingCurrency
        }
    }
`;

export const GET_FONAV_CURVE = gql`
    query getFoNavCurve($curveId: GraphQLObjectId!, $startDate: GraphQLDateString!, $endDate: GraphQLDateString!) {
        curveDefinition(_id: $curveId) {
            _id
            name
            type
            definition {
                currency
                instruments {
                    instrumentId
                    instrument {
                        _id
                        name
                        model {
                            legs {
                                _t
                                maturityPeriod
                            }
                        }
                        startSeries: timeSeries(typeIn: ["Price(Close)"], startDate: $startDate, endDate: $startDate) {
                            dates
                            values
                            items {
                                date
                                value
                            }
                        }
                        endSeries: timeSeries(typeIn: ["Price(Close)"], startDate: $endDate, endDate: $endDate) {
                            dates
                            values
                            items {
                                date
                                value
                            }
                        }
                    }
                }
            }
        }
    }
`;

export const GET_FONAV_SWAPS = GET_FONAV_CURVE;

export const GET_FONAV_BONDS = gql`
    query getFoNavBonds($startDate: GraphQLDateString!, $endDate: GraphQLDateString!, $aliasIn: [String!], $nameIn: [String!]) {
        instruments(aliasIn: $aliasIn, nameIn: $nameIn) {
            _id
            name
            isin
            maturityDate
            spreadStart: zeroSpread(date: $startDate)
            spreadEnd: zeroSpread(date: $endDate)
            yieldStart: yield(date: $startDate)
            yieldEnd: yield(date: $endDate)
            lastPrice: pxLast(date: $endDate) {
                date
                value
            }
        }
    }
`;

export const GET_FONAV_CDS_INSTRUMENTS = gql`
    query getFoNavCdsInstruments($nameIn: [String!]) {
        instruments(nameIn: $nameIn) {
            _id
            name
        }
    }
`;

export const GET_FONAV_FX_INSTRUMENTS = gql`
    query getFoNavFxInstruments($nameIn: [String!]) {
        instruments(nameIn: $nameIn) {
            _id
            name
        }
    }
`;

export const GET_FONAV_TIMESERIES = gql`
    query getFoNavTimeseries($filter: TimeSeriesFilterInput) {
        timeseries(includeItems: true, filter: $filter) {
            _id
            dates
            values
            instrument {
                _id
                name
            }
        }
    }
`;

export const GET_FONAV_CALENDAR = gql`
    query getFoNavCalendar($names: [CalendarNameEnum!], $years: [String!]) {
        calendar(names: $names, years: $years) {
            names
            calendarEvents {
                date
                state
            }
        }
    }
`;

export const GET_FONAV_POSITIONS = gql`
    query getFoNavPositions($fundId: GraphQLObjectId!, $date: GraphQLDateString!) {
        positions: tradingmanager(
            filterZeroPositions: true
            filter: { clientIds: [$fundId], endDate: $date }
            lookThrough: false
            baseCurrency: SEK
        ) {
            modelType
            isCashAccount
            instrument {
                modelType
            }
            swaplab2Results(date: $date) {
                creditYieldDelta
                interestRateYieldDelta
            }
        }
    }
`;

export const GET_FONAV_FUND_NAV = gql`
    query getFoNavFundNav($fundId: GraphQLObjectId!, $date: GraphQLDateString!) {
        previousNav: navs(clientId: $fundId, date: $date, lastOnly: true) {
            date
            client {
                name
            }
            data {
                classes {
                    instrumentId
                    name
                    navBeforeAdjustmentsBeforeOrders
                    navAfterAdjustmentsAfterOrders
                    fxRate
                    navCurrency
                    navPerUnitReturn1D
                }
            }
        }
    }
`;

export const GET_FONAV_ESTIMATE_INSTRUMENTS = gql`
    query getFoNavEstimateInstruments(
        $startDate: GraphQLDateString!
        $endDate: GraphQLDateString!
        $bondNameIn: [String!]
        $swapNameIn: [String!]
        $cdsNameIn: [String!]
    ) {
        bondInstruments: instruments(nameIn: $bondNameIn) {
            name
            spreadStart: zeroSpread(date: $startDate)
            spreadEnd: zeroSpread(date: $endDate)
        }
        swapInstruments: instruments(nameIn: $swapNameIn) {
            name
            startSeries: timeSeries(typeIn: ["Price(Close)"], startDate: $startDate, endDate: $startDate) {
                dates
                values
                items {
                    date
                    value
                }
            }
            endSeries: timeSeries(typeIn: ["Price(Close)"], startDate: $endDate, endDate: $endDate) {
                dates
                values
                items {
                    date
                    value
                }
            }
        }
        cdsInstruments: instruments(nameIn: $cdsNameIn) {
            _id
            name
        }
    }
`;
